export class AuthenticationServiceMock {
    authenticate() {}
    subscribeOnAuth() {}
}
